module.exports = __webpack_public_path__ + "img/no-need.350688fc.svg";